import { useForm } from 'components/form/Form';
import { useValue } from 'components/form/hook/useValue';
import { classNames } from 'libs/react';
import { useIf } from 'libs/react';
import { useState } from 'libs/react';
import { useWatch } from 'libs/react';
import { FormFieldError } from 'components/form/FormFieldError';
import { FormFieldInfos } from 'components/form/FormFieldInfos';
import { FormFieldLabel } from 'components/form/FormFieldLabel';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import './FormInput.scss';
import { GoogleAutocompleteInput } from './private/inputs/GoogleAutocompleteInput';
/**
 * @component FormGoogleAutocompleteInput
 * @since 1.0.0
 */
export function FormGoogleAutocompleteInput(props) {
    let { name, size, style, picto, badge, label, infos, error, required, disabled, placeholder, prefix, suffix, onLocationSelected } = Object.assign({ size: 'medium', name: '', style: 'normal' }, props);
    const form = useForm();
    const [value, setValue] = useValue(name, props.value || '', props.defaultValue || '');
    const [focused, setFocused] = useState(false);
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        setFocused(false);
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        setFocused(true);
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(value) {
        setValue(value);
    }
    useIf(focused, props.onFocus, props.onBlur);
    useWatch(() => {
        if (props.onChange) {
            props.onChange(value);
        }
    }, [value]);
    // Update internal value when prop changes
    useWatch(() => {
        if (props.value !== undefined) {
            setValue(props.value);
        }
    }, [props.value]);
    if (error == null) {
        error = form.getError(name);
    }
    const className = classNames('form-input', 'form-input--' + size, 'form-input--' + style, { 'form-input--is-required': required }, { 'form-input--is-disabled': disabled }, { 'form-input--is-focused': focused }, { 'form-input--has-label': label !== '' }, { 'form-input--has-value': value !== '' }, { 'form-input--has-picto': picto }, { 'form-input--has-badge': badge }, { 'form-input--has-error': error }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "form-input-field" },
            React.createElement("div", { className: "form-input-field-head" },
                React.createElement(FormFieldLabel, { className: "form-input-label", size: size, style: style, label: label, required: required, disabled: disabled }),
                React.createElement(FormFieldInfos, { className: "form-input-infos", size: size, style: style, infos: infos })),
            React.createElement("div", { className: "form-input-field-body" },
                prefix && React.createElement("div", { className: "form-input-prefix" }, prefix),
                React.createElement(GoogleAutocompleteInput, { name: name, value: value, required: required, disabled: disabled, placeholder: placeholder, onBlur: onBlur, onFocus: onFocus, onChange: onChange, onLocationSelected: onLocationSelected }),
                picto && React.createElement(Icon, { className: "form-input-picto", value: picto }),
                badge && React.createElement(Text, { className: "form-input-badge", value: badge }),
                suffix && React.createElement("div", { className: "form-input-suffix" }, suffix))),
        React.createElement(FormFieldError, { error: error })));
}
